var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueRecaptcha',{ref:"captcha",attrs:{"sitekey":_vm.chrome.recaptchaKey,"loadRecaptchaScript":true,"theme":_vm.theme,"size":_vm.size,"language":_vm.currentLang},on:{"verify":_vm.onVerify,"error":_vm.onError,"expired":_vm.onError}})}
var staticRenderFns = []

export { render, staticRenderFns }